import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Header/Header.js'
import '@isceco/widget-library2/basic-elements/LanguageSwitcher/LanguageSwitcher.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'
import '@isceco/widget-library2/basic-elements/ActionMenu/ActionMenu.js'
import WebComponent from '../../WebComponent.js'
import ConfigUtil from '../../services/ConfigUtil'

export default class Header extends WebComponent {

  get translationFile() {
    return './views/Header/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.logoutPage = ''
    this.myAccountPage = ''
    new ConfigUtil().retrieveConfiguration()
      .then(config => {
        this.logoutPage = config.logoutPage
        this.myAccountPage = config.myAccountPage
      })
      .then(_ => {
        this.render()
      })
  }

  get css() {
    return css`
      .user-language {
        display: flex;
        align-items: end;
        flex-direction: column;
      }
    `
  }

  getTemplate() {
    return html`
      <isceco-header text="${this.i18n.translate('header.text')}">
        <div class="user-language">
          <isceco-language></isceco-language>
          ${this._renderUserMenu()}
        </div>
      </isceco-header>
    `
  }

  _renderUserMenu() {
    const isAuthenticated = window.keycloak?.authenticated

    if (!isAuthenticated && window.isAnonymousAccess) {
      return html``
    }

    return html`
      <div class="user-menu">
        <isceco-action-menu id="user-action-menu"
                            .items="${[
                              {
                                icon: 'user',
                                text: this.i18n.translate('header.my-account'),
                                url: this.myAccountPage,
                                target: '_blank'
                              },
                              {
                                icon: 'sign out',
                                text: this.i18n.translate('header.logout'),
                                callback: _ => window.keycloak.logout({redirectUri: this.logoutPage})
                              }
                            ]}">
          <isceco-link slot="wrapper"
                       text="${this.displayName()}"
                       icon="user circle outline"
          </isceco-link>
        </isceco-action-menu>
      </div>
    `
  }

  displayName = () => {
    if (!isEmpty(window.keycloak) && window.keycloak.tokenParsed) {
      return `${window.keycloak.tokenParsed.given_name} ${window.keycloak.tokenParsed.family_name}`
    } else {
      return ''
    }
  }
}

customElements.define('eform-frontend-header', Header)
